/** @type {import('./index').Options}  */
const options = {};

export default options;
